export default __webpack_public_path__ + "static/media/maxinet.08f9194d.jpg";